import { MedicalQuestion } from "../../data-model/medicalQuestion";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "../postCall/bearerToken";

interface UpdateNchQuestionnairePayload {
  identifier: string;
  question_tree: MedicalQuestion[];
}

export const updateNchQuestionnaire = async (
  payload: UpdateNchQuestionnairePayload,
): Promise<void> => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("No token found");
    }
    const response = await fetch(
      API_ENDPOINTS.NEW_CENTURY_HEALTH_QUESTIONNAIRE_UPDATE,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      },
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    logError(error as Error, "Error updating New Century Health questionnaire");
    throw error;
  }
};
